/* eslint-disable */
import r1 from './r1.js'
import a from './aaa.js'

var s = function () {
  function t() {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, t)
  }
  return r1(t, null, [{
    key: "start",
    value: function () {
      var e = 0 < arguments.length && void 0 !== arguments[0] && arguments[0];
      1 < arguments.length && void 0 !== arguments[1] && arguments[1];
      t.checkMouseDirection = e,
        window.mouseSpeed = {
          x: 0,
          y: 0
        },
        window.mouseLast = new a.default,
        window.mouseDirection = new a.default,
        window.mouse = new a.default,
        window.addEventListener("mousemove", t.move)
    }
  }, {
    key: "move",
    value: function (e) {
      t.checkMouseDirection && t.getDirection(e),
        window.mouse.set(e.clientX, e.clientY)
    }
  }, {
    key: "getDirection",
    value: function (e) {
      window.mouse.x < e.pageX ? window.mouseDirection.x = 1 : window.mouse.x > e.pageX ? window.mouseDirection.x = -1 : window.mouseDirection.x = 0,
        window.mouse.y < e.pageY ? window.mouseDirection.y = 1 : window.mouse.y > e.pageY ? window.mouseDirection.y = -1 : window.mouseDirection.y = 0
    }
  }, {
    key: "getSpeed",
    value: function () {
      window.mouseSpeed.x = window.mouse.x - window.mouseLast.x,
        window.mouseSpeed.y = window.mouse.y - window.mouseLast.y,
        window.mouseLast.copy(window.mouse)
    }
  }]),
    t
}();
var t = { default: s }

export default t
